<div class="percentageText" aria-hidden="true">
    {{percentage | number: '1.0-0'}}%
</div>
<div class="percentageBarWrapper" [attr.aria-label]="percentage + '%'">
    <div class="percentageBar" aria-hidden="true">
        <div class="fill" [style.width]="percentage + '%' ">
        </div>
    </div>
</div>
